import Layout from "./components/Layout/Layout";
import { CheckSubscription } from "./components/Subscription/CheckSubscription";
import SystemMessage from "./components/SystemMessage/Index";
import Routes from "./Routes";
import { useProfile } from "./contexts/UserProvider";
import ProfileForm from "./components/Forms/ProfileForm";
import Section from "./components/Section";
import { useAuth } from "./lib/auth";
import { Footer } from "./components/Footer/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToPosition } from "./lib/scrollToPosition";

const App = () => {
  const { user } = useAuth();
  const profile = useProfile();
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToPosition(0);
  }, [pathname]);

  let component = <Routes />;
  if (user?.email_verified === false) {
    component = <SystemMessage message='verifyEmail' />;
  } else if (!profile) {
    component = (
      <Section>
        <ProfileForm />
      </Section>
    );
  }

  return (
    <Layout footer={<Footer />}>
      <CheckSubscription />
      {component}
    </Layout>
  );
};

export default App;
